var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-file-input", {
        attrs: { label: "Select file" },
        model: {
          value: _vm.computedFile,
          callback: function ($$v) {
            _vm.computedFile = $$v
          },
          expression: "computedFile",
        },
      }),
      Boolean(_vm.error)
        ? _c("v-alert", { attrs: { type: "error", outlined: "" } }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _c(
        "v-btn",
        {
          attrs: { text: "", "x-small": "", outlined: "", color: "primary" },
          on: { click: _vm.downloadTemplate },
        },
        [
          _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
            _vm._v("mdi-download"),
          ]),
          _vm._v("get template "),
        ],
        1
      ),
      _c("v-switch", {
        attrs: { dense: "", label: "Replace existing resources" },
        model: {
          value: _vm.computedReplace,
          callback: function ($$v) {
            _vm.computedReplace = $$v
          },
          expression: "computedReplace",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }